import React from 'react';
import type { SettingsSection } from '../types';
import { SECTION_TABS } from '../constants';

interface SectionTabsProps {
  activeSection: SettingsSection;
  onSectionChange: (section: SettingsSection) => void;
}

export const SectionTabs: React.FC<SectionTabsProps> = ({ activeSection, onSectionChange }) => {
  return (
    <div className="mb-4 overflow-x-auto">
      <div className="flex min-w-fit gap-2">
        {SECTION_TABS.map((tab) => {
          const isActive = activeSection === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onSectionChange(tab.id)}
              className={`rounded-md border px-3 py-2 text-left transition-colors ${
                isActive
                  ? 'border-blue-500 bg-blue-50 text-blue-700 dark:border-blue-400 dark:bg-blue-900/20 dark:text-blue-300'
                  : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'
              }`}
            >
              <div className="text-sm font-semibold leading-4">{tab.label}</div>
              <div className="text-[11px] opacity-80 mt-0.5">{tab.hint}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
